// @ts-nocheck
/* eslint-enable */
/* eslint-disable react/no-multi-comp */
// App
import React from 'react';

// Misc / utils
import * as S from './styles';

const FaqSection = ({ className, faqData, questionHeadingLevel = 'h2' }) => {
  if (faqData && faqData.data.length < 1) {
    return null;
  }

  const standardAnswerFormat = (answer) => {
    return <S.FaqAnswer>{answer}</S.FaqAnswer>;
  };

  const listAnswerFormat = (question) => {
    const answerType = question.answerType;
    const ListElement = answerType === 'unorderedList' ? 'ul' : 'ol';

    return (
      <>
        {question.listHeader && <S.FaqAnswerListHeader>{question.listHeader}</S.FaqAnswerListHeader>}
        <S.FaqAnswerList as={ListElement} listStyle={ListElement}>
          {Array.isArray(question.answer) &&
            question.answer.length &&
            question.answer.map((answer, idx) => {
              return <S.FaqAnswerLi key={`answer-${idx}-${answer}`}>{answer}</S.FaqAnswerLi>;
            })}
        </S.FaqAnswerList>
      </>
    );
  };

  return (
    <>
      {faqData &&
        faqData.data.map((question) => {
          const answerType = question.answerType;

          return (
            <section className={className} key={`question-id-${question.question}`}>
              <S.FaqQuestion as={questionHeadingLevel}>{question.question}</S.FaqQuestion>
              {answerType === 'answer' && standardAnswerFormat(question.answer)}
              {(answerType === 'unorderedList' || answerType === 'orderedList') && listAnswerFormat(question)}
            </section>
          );
        })}
    </>
  );
};

export default FaqSection;
